jQuery_T4NT(document).on('keydown', '#t4s-mini_cart .t4s-btn__checkout', function(event) {
	//var checkoutButton = $('.t4s-btn__checkout');
	var closeButton = $('.t4s-drawer__close');
	// Add an event listener to the checkout button to trap focus
	if(event.shiftKey && event.key === 'Tab'){

    }else if (event.key === 'Tab') {
		event.preventDefault(); // Prevent default tab behavior
		closeButton.focus(); // Move focus to the close button
	}
});

jQuery_T4NT(document).on('keydown','.t4s-push-menu-btn',function(event){
    if (event.key === 'Enter') {
setTimeout(function(){
      event.preventDefault(); // Prevent default tab behavior
     $('#data-tab-mb-item1').focus(); // Move focus to the close button
    },200);
           }
});

jQuery_T4NT(document).on('keydown','.t4s-drawer-menu__close',function(event){
//var checkoutButton = $('.t4s-btn__checkout');
  var closeButton = $('.menumob1 a');
var restoreBtn = $('.t4s-push-menu-btn');
  // Add an event listener to the checkout button to trap focus

    if (event.key === 'Tab') {
      event.preventDefault(); // Prevent default tab behavior
      closeButton.focus(); // Move focus to the close button
    }else if (event.key === 'Enter') {
      setTimeout(function(){
      event.preventDefault(); // Prevent default tab behavior
      restoreBtn.focus(); // Move focus to the close button
      },500);
    }
 
});

jQuery_T4NT(document).on('keydown', '.t4s-site-nav__cart a[href="/cart"]', function(event) {
	//  var cartLink = $('.t4s-site-nav__cart a[href="/cart"]');
	var miniCart = $('#t4s-mini_cart .t4s-drawer__close');
	setTimeout(function() {
		// Prevent the default link behavior
		event.preventDefault();
		localStorage.setItem('lastFocusedElement', 'header-cart');
      localStorage.setItem('tabShiftElement', '#t4s-mini_cart .t4s-btn__checkout ');
		// Check if the pressed key is Enter (key code 13)
		if (event.key === 'Enter') {
			// Move focus to the mini cart
			miniCart.focus();
		}
	}, 50);
});
jQuery_T4NT(document).on('keydown', '#t4s-mini_cart', function(event) {
        if (event.key === 'Escape') {
			//  console.log('Working');
			$('#header-cart').focus();	
        }
    });
jQuery_T4NT(document).on('keydown', '.t4s-product-form__submit', function(event) {
	var miniCart = $('#t4s-mini_cart .t4s-drawer__close');
	setTimeout(function() {
		// Prevent the default link behavior
		event.preventDefault();
		// Check if the pressed key is Enter (key code 13)
		if (event.key === 'Enter') {
			// Move focus to the mini cart
			miniCart.focus();
		}
	}, 250);
});
jQuery_T4NT(document).on('keydown', '.signup_btn', function(event) {
	//var suButton = $('.signup_btn');
	var closesuButton = $('#t4s-login-sidebar .t4s-drawer__close');
	// Add an event listener to the checkout button to trap focus
	if(event.shiftKey && event.key === 'Tab'){
event.preventDefault();
$('.t4s_btn_submmit').focus();
    }else if (event.key === 'Tab') {
		event.preventDefault(); // Prevent default tab behavior
		closesuButton.focus(); // Move focus to the close button
	}else if (event.key == 'Enter'){
       localStorage.setItem('tabShiftElement', '#t4s-login-sidebar .login_linka.backsign');
    }
});
jQuery_T4NT(document).on('keydown', '.t4s-site-nav__account a[href="/account"]', function(event) {
	// var accountLink = $('.t4s-site-nav__account a[href="/account"]');
	var miniAc = $('#t4s-login-sidebar .t4s-drawer__close');
	//console.log('Working');
	setTimeout(function() {
		// Prevent the default link behavior
		event.preventDefault();
		localStorage.setItem('lastFocusedElement', 'header-account');
        localStorage.setItem('tabShiftElement', '#t4s-login-sidebar .signup_btn');
		// Check if the pressed key is Enter (key code 13)
		if (event.key === 'Enter') {
			// Move focus to the mini cart
			miniAc.focus();
		}
	}, 250);
});
jQuery_T4NT(document).on('keydown', '.login_linka', function(event) {
	//var suButton = $('.signup_btn');
	var closesuButton = $('#t4s-login-sidebar .t4s-drawer__close');
	// Add an event listener to the checkout button to trap focus
	if(event.shiftKey && event.key === 'Tab'){
event.preventDefault();
if ($(this).hasClass('backrec')) {
$('#recover_login-sidebar .t4s_btn_submmit').focus();
}else{
$('#create_login-sidebar .t4s_btn_submmit').focus();   
}
    }else if (event.key === 'Tab') {
		event.preventDefault(); // Prevent default tab behavior
		closesuButton.focus(); // Move focus to the close button
	} else if (event.key === 'Enter') {
localStorage.setItem('tabShiftElement', '#t4s-login-sidebar .signup_btn');
		setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
			closesuButton.focus(); // Move focus to the close button 
		}, 250);
	}
});
jQuery_T4NT(document).on('keydown', '.precover_link', function(event) {
	//var suButton = $('.signup_btn');
	var closesuButton = $('#t4s-login-sidebar .t4s-drawer__close');
	// Add an event listener to the checkout button to trap focus
	if (event.key === 'Enter') {
localStorage.setItem('tabShiftElement', '#t4s-login-sidebar .login_linka.backrec');
		setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
			closesuButton.focus(); // Move focus to the close button 
		}, 250);
	}
});
jQuery_T4NT(document).on('keydown', '.t4s-drawer__close', function(event) {
	// Add an event listener to the checkout button to trap focus
	if (event.key === 'Enter') {
		setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
			//       console.log('Working');
			var lastFocusedElementId = localStorage.getItem('lastFocusedElement');
			if (lastFocusedElementId) {
				$('#' + lastFocusedElementId).focus();
			} else {
				$('header').focus();
			}
		}, 50);
	}else if(event.shiftKey && event.key === 'Tab'){
setTimeout(function() {
      event.preventDefault();
var tabShiftElementId = localStorage.getItem('tabShiftElement');  
  if(tabShiftElementId){
    $(tabShiftElementId).focus();    
  }
	}, 50);
    }
});
 
 jQuery_T4NT(document).on('keydown', '.mi3', function(event) {
    // Check if the pressed key is 'Tab' (key code 9)
    if (event.which === 9) {
      // Remove the 'is-action__hover' class from the menu item
      $('.t4s-menu-item.has--children').removeClass('is-action__hover');
    }
  });
jQuery_T4NT(document).on('keydown', '.t4s-pr__notify-stock', function(event) {
	var closesuButton = $('#t4s-pr-popup__notify-stock input[type="email"]');
 var tabButton = jQuery_T4NT('.t4s-modal-close');
	// Add an event listener to the checkout button to trap focus
	if (event.key === 'Enter') {
setTimeout(function() {
		event.preventDefault(); // Prevent default tab behavior
		closesuButton.focus(); // Move focus to the close button
	}, 250);
	}else if (event.shiftKey && event.key === 'Tab') {
       
    }else if (event.key === 'Tab') {
       if (jQuery_T4NT(this).closest('.t4s-product-quick-shop').length) {
      event.preventDefault();
      tabButton.focus();       
}
    }
});
jQuery_T4NT(document).on('keydown', '.mfp-close', function(event) {
	var closesuButton = $('#t4s-pr-popup__notify-stock input[type="email"]');
	// Add an event listener to the checkout button to trap focus
	if (event.key === 'Tab') {
		event.preventDefault(); // Prevent default tab behavior
		closesuButton.focus(); // Move focus to the close button
	}
});
jQuery_T4NT(document).on('keydown', '.mini_cart_tool_btn.is--note', function(event) {
	// Add an event listener to the checkout button to trap focus
	if (event.key === 'Enter') {
		setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			localStorage.setItem('lastFocusedElementClass', 'mini_cart_tool_btn.is--note');
			localStorage.setItem('resumeElement', 'CartSpecialInstructions');
			$('#CartSpecialInstructions').focus();
		}, 250);
	}
});
jQuery_T4NT(document).on('keydown', '.t4s-pr__pswp-btn', function(event) {
	// Add an event listener to the checkout button to trap focus
	if (event.key === 'Enter') {
		setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			$('.pswp__button--zoom').focus();
addWrapperDiv();
		}, 250);
	}
});
jQuery_T4NT(document).on('click', '.t4s-pr__pswp-btn', function(event) {
	// Add an event listener to the checkout button to trap focus
		setTimeout(function() {
		addWrapperDiv();
		}, 250);
	
});
jQuery_T4NT(document).on('keydown', '.pswp_thumb_item', function(event) {
	// Add an event listener to the checkout button to trap focus
	if (event.shiftKey && event.key === 'Tab') {

	}else if (event.key === 'Tab') {
if ($(this).is($('.pswp_thumb_item').last())) {	
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			$('.pswp__button--zoom').focus();
}
	}else if (event.key === 'Enter' || event.key === ' '){
      $(this).click();
    }
});
jQuery_T4NT(document).on('keydown', '.pswp__button--zoom', function(event) {
	// Add an event listener to the checkout button to trap focus
	if (event.shiftKey && event.key === 'Tab') {
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			$('.pswp_thumb_item').last().focus();
	}
});
jQuery_T4NT(document).on('keydown', '.pswp__button--close', function(event) {
	// Add an event listener to the checkout button to trap focus
	if (event.key === 'Enter') {
		setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			$('.t4s-pr__pswp-btn').focus();
		}, 250);
	}
});
jQuery_T4NT(document).on('keydown', '.pswp--open', function(event) {
	// Add an event listener to the checkout button to trap focus
	if (event.key === 'Escape') {
		setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			$('.t4s-pr__pswp-btn').focus();
		}, 250);
	}
});
jQuery_T4NT(document).on('keydown', '#CartSpecialInstructions', function(event) {
	// Add an event listener to the checkout button to trap focus
	if (event.shiftKey && event.key === 'Tab') {		
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			$('.t4s-mini_cart-tool__content.is--note .t4s-mini_cart-tool__back').focus();
	}
});
jQuery_T4NT(document).on('keydown', '#ShippingCountry_mini_cart', function(event) {
	// Add an event listener to the checkout button to trap focus
	if (event.shiftKey && event.key === 'Tab') {		
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			$('.t4s-mini_cart-tool__content.is--rates .t4s-mini_cart-tool__back').focus();
	}
});
jQuery_T4NT(document).on('keydown', '#CartDiscountcode', function(event) {
	// Add an event listener to the checkout button to trap focus
	if (event.shiftKey && event.key === 'Tab') {		
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			$('.t4s-mini_cart-tool__content.is--discount .t4s-mini_cart-tool__back').focus();
	}
});
jQuery_T4NT(document).on('keydown', '.mini_cart_tool_btn.is--rates', function(event) {
	// Add an event listener to the checkout button to trap focus
	if (event.key === 'Enter') {
		setTimeout(function() {
			event.preventDefault();
			localStorage.setItem('lastFocusedElementClass', 'mini_cart_tool_btn.is--rates');
			localStorage.setItem('resumeElement', 'ShippingCountry_mini_cart');
			$('#ShippingCountry_mini_cart').focus();
		}, 50);
	}
});
jQuery_T4NT(document).on('keydown', '.mini_cart_tool_btn.is--discount', function(event) {
	// Add an event listener to the checkout button to trap focus
	if (event.key === 'Enter') {
		setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			localStorage.setItem('lastFocusedElementClass', 'mini_cart_tool_btn.is--discount');
			localStorage.setItem('resumeElement', 'CartDiscountcode');
			$('#CartDiscountcode').focus();
		}, 250);
	}
});
jQuery_T4NT(document).on('keydown', '.t4s-mini_cart-tool__back', function(event) {
	// Add an event listener to the checkout button to trap focus
	if (event.shiftKey && event.key === 'Tab') {
      
    }else if (event.key === 'Tab') {
		setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			var resumeElement = localStorage.getItem('resumeElement');
			$('#' + resumeElement).focus();
		}, 250);
	} else if (event.key === 'Enter') {
		setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			var lastFocusedElementClass = localStorage.getItem('lastFocusedElementClass');
			$('.' + lastFocusedElementClass).focus();
		}, 250);
	}
});
jQuery_T4NT(document).on('keydown', '.t4s-mini_cart-tool__content', function(event) {
        if (event.key === 'Escape') {
         setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			var lastFocusedElementClass = localStorage.getItem('lastFocusedElementClass');
			$('.' + lastFocusedElementClass).focus();
		}, 250);
        }
    });
jQuery(document).ready(function() {
localStorage.setItem('ci',-1);
localStorage.setItem('cp',1);
        $('.flickityt4s-page-dots .dot').each(function() {
            $(this).on('keydown', function(event) {
                if (event.key === 'Enter' || event.keyCode === 13) {
                    $(this).click();
                }
            });
        });
  setTimeout(function(){
    checkHidden();
checkCurrent();
},200);
 setTimeout(function(){
     var $stickyAtcContent = $('.statc').html();
$('.statc').remove();
    $('main').append($stickyAtcContent);
 var h=$('.t4s-sticky-atc').outerHeight();
    $('.t4s-sticky-atc').css('bottom',h);
  },500);
});

jQuery(document).on('keydown', '.t4s-search-header__input', function(event) {
	if (event.key != 'Tab') {
		//  event.preventDefault();
		$('.t4s-frm-search__results').css({
			'opacity': '1',
			'visibility': 'visible',
			'pointer-events': 'all'
		});
	}
});
jQuery(document).on('keydown', function(event) {
	if (!$(event.target).closest('.t4s-pa.t4s-frm-search__results').length) {
		return;
	}
	let searchResults = $('.t4s-pa.t4s-frm-search__results a');
	if (searchResults.length === 0) return;
	// Retrieve the current index from localStorage
	let currentIndex = parseInt(localStorage.getItem('ci'), 10);
	if (isNaN(currentIndex)) {
		currentIndex = -1;
	}
	switch (event.key) {
		case 'ArrowDown':
			if (currentIndex < searchResults.length - 1) {
				currentIndex++;
				searchResults.eq(currentIndex).focus();
				localStorage.setItem('ci', currentIndex); // Update localStorage
			}
			break;
		case 'ArrowUp':
			if (currentIndex > 0) {
				currentIndex--;
				searchResults.eq(currentIndex).focus();
				localStorage.setItem('ci', currentIndex); // Update localStorage
			}
			break;
		case 'Enter':
			searchResults = $('.t4s-pa.t4s-frm-search__results a');
			currentIndex = 0;
			searchResults.eq(currentIndex).focus();
			localStorage.setItem('ci', currentIndex); // Update localStorage
			break;
		case 'Tab':
			currentIndex++;
			localStorage.setItem('ci', currentIndex); // Update localStorage
			break;
		case 'Escape':
			$('.t4s-pa.t4s-frm-search__results').css({
				'opacity': '0',
				'visibility': 'hidden'
			});
			$('.t4s-search-header__input').focus();
			$('.t4s-search-header__input').removeAttr('aria-activedescendant');
			currentIndex = -1;
			localStorage.setItem('ci', currentIndex); // Update localStorage
			break;
	}
	if (currentIndex >= 0 && currentIndex < searchResults.length) {
		const currentId = searchResults.eq(currentIndex).attr('data-rid');
		$('.t4s-search-header__input').attr('aria-activedescendant', currentId);
		//   console.log('Current id:', currentId);
	}
	// console.log(currentIndex);
});
jQuery_T4NT(document).on('keydown', '.t4s-page_cart__edit', function(event) {
	var miniCart = $('.t4s-drawer__close');	
		// Check if the pressed key is Enter (key code 13)
		if (event.key === 'Enter') {
setTimeout(function() {
		// Prevent the default link behavior
		event.preventDefault();
			localStorage.setItem('lastModalElement', '.t4s-page_cart__edit');
			localStorage.setItem('tabModalElement', '.t4s-product-qs__title a');
          localStorage.setItem('tabShiftElement', 'button[data-testid="sheet-open-button"]');
 localStorage.setItem('escElement', '.t4s-page_cart__edit');
			// Move focus to the mini cart
			miniCart.focus();
}, 50);
		}	
});
jQuery_T4NT(document).on('keydown', '.t4s-mini_cart__edit', function(event) {
	var miniCart = $('.t4s-modal-close');
		// Check if the pressed key is Enter (key code 13)
		if (event.key === 'Enter') {
setTimeout(function() {
		// Prevent the default link behavior
		event.preventDefault();
			localStorage.setItem('lastModalElement', '.t4s-mini_cart__edit');
			localStorage.setItem('tabModalElement', '.t4s-product-qs__title a');
          localStorage.setItem('tabShiftElement', '.shopify-payment-button__more-options');
  localStorage.setItem('escElement', '#header-cart');
			// Move focus to the mini cart
			miniCart.focus();
	}, 200);
		}
});
jQuery_T4NT(document).on('keydown', '#t4s-menu-drawer', function(event) {
        if (event.key === 'Escape') {
			//  console.log('Working');
			$('.t4s-push-menu-btn').focus();	
        }
    });
jQuery_T4NT(document).on('keydown', '.t4s-modal-close', function(event) {
	// Add an event listener to the checkout button to trap focus
if (event.shiftKey && event.key === 'Tab') {
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			var tabShiftElement = localStorage.getItem('tabShiftElement');
			$(tabShiftElement).focus();
	} else if (event.key === 'Tab') {
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			var tabModalElement = localStorage.getItem('tabModalElement');
			$(tabModalElement).focus();
	} else if (event.key === 'Enter') {
		setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			var lastModalElement = localStorage.getItem('lastModalElement');
			$(lastModalElement).focus();
		}, 200);
	}
});
// Attach a click event handler to the element with attribute 'data-dropdown-open'
function handleDropdownOpen() {
	// Check if the element does not have class 'is--clicked'
	if (!$('[data-dropdown-open]').hasClass('is--clicked')) {
		// Add aria-expanded="true"
		$('[data-dropdown-open]').attr('aria-expanded', 'true');
		var selectedId = $('[data-sticky-select] .is--selected').attr('id');
		$('[data-dropdown-open]').attr('aria-activedescendant', selectedId);
	} else {
		$('[data-dropdown-open]').attr('aria-expanded', 'false');
		$('[data-dropdown-open]').attr('aria-activedescendant', '');
	}
}
$('[data-dropdown-open]').on('click', handleDropdownOpen);
// Handle Enter key press
$('[data-dropdown-open]').on('keydown', function(event) {
	if (event.key === 'Enter' || event.keyCode === 13) {
		handleDropdownOpen.call(this);
	}
});
$('[data-sticky-select] [data-dropdown-item]').on('click', handleDropdownOpen);
$('[data-sticky-select] [data-dropdown-item]').on('keydown', function(event) {
	if (event.key === 'Enter' || event.keyCode === 13) {
		handleDropdownOpen.call(this);
	}
});
jQuery_T4NT(document).on('keydown', '#shopify-section-mb_nav a:last,#shopify-section-mb_cat a:last', function(event) {
	var closeButton = $('#data-tab-mb-item1');
	// Add an event listener to the checkout button to trap focus
	if(event.shiftKey && event.key === 'Tab'){

    }else if (event.key === 'Tab') {
		event.preventDefault(); // Prevent default tab behavior
closeButton.focus(); // Move focus to the close button
	}
});
jQuery_T4NT(document).on('keydown', '#data-tab-mb-item1', function(event) {
    var closeButton = $('#shopify-section-mb_nav a:last');
    var closeButton2 = $('#shopify-section-mb_cat a:last');
    var dataTab = $('#data-tab-mb-item1');
    
    // Check if Shift+Tab key is pressed
    if(event.shiftKey && event.key === 'Tab') {
        event.preventDefault(); // Prevent default tab behavior
        
        // Move focus based on the presence of the is--active class
        if (dataTab.hasClass('is--active')) {
            closeButton.focus();
        } else {
            closeButton2.focus();
        }
    }
});
jQuery_T4NT(document).on('keydown', '#t4s-backToTop, .skip_to_menu', function(event) {
	var closesuButton = $('.logolink');
	// Add an event listener to the checkout button to trap focus
	if (event.key === 'Enter') {
		setTimeout(function() {
			closesuButton.focus(); // Move focus to the close button
		}, 250);
	}
});
jQuery_T4NT(document).on('keydown', '.t4s-swatch__item', function(event) {
if (event.key == 'Enter' || event.key === ' ') {
event.preventDefault();
  $(this).click();
//console.log('Working');
}
});
jQuery_T4NT(document).on('keydown', 'button[data-testid="sheet-open-button"]', function(event) {
	//console.log('Working');
	//var suButton = $('.signup_btn');
	var closesuButton = $('.t4s-modal-close');
	// Add an event listener to the checkout button to trap focus
	 if(event.shiftKey && event.key === 'Tab'){
       
     }  else if (event.key === 'Tab') {
		setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
			closesuButton.focus(); // Move focus to the close button
		}, 50);
	}
});
jQuery_T4NT('.tbtn_menu').on('keydown', function(event) {
   if (event.keyCode === 13 || event.keyCode === 32) {
    // Prevent default action for both 'Enter' and 'Space' keys
    event.preventDefault();

    // Toggle the 'is-action__hover' class on menuItem
    var $menuItem = $(this).closest('.t4s-menu-item.has--children');
    $menuItem.toggleClass('is-action__hover');

    // Toggle aria-expanded attribute on button
    var isExpanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !isExpanded);

    // Set aria-hidden attribute on submenu
    var $submenu = $menuItem.find('.t4s-sub-menu');
    $submenu.attr('aria-hidden', isExpanded);

    // Focus on first submenu item if expanded
    if (!isExpanded) {
      $submenu.find('.mi1 a').focus();
    }
  }
});
jQuery_T4NT('.tbtn_menu').on('click', function(event) {
    // Toggle the 'is-action__hover' class on menuItem
    var $menuItem = $(this).closest('.t4s-menu-item.has--children');
    $menuItem.toggleClass('is-action__hover');

    // Toggle aria-expanded attribute on button
    var isExpanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !isExpanded);

    // Set aria-hidden attribute on submenu
    var $submenu = $menuItem.find('.t4s-sub-menu');
    $submenu.attr('aria-hidden', isExpanded);

});
jQuery_T4NT(document).on('keydown', '.t4s-col-thumb .t4s-carousel__nav-item', function(event) {
    if (event.key === 'Enter') {
    setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
			checkCurrent();  
		}, 100);
    }
});
jQuery_T4NT(document).on('click', '.t4s-col-thumb .t4s-carousel__nav-item', function(event) {   
setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
			checkCurrent();   
		}, 100);
});
 jQuery_T4NT(document).on('keydown', function(event) {
        // Check if the dropdown is open
        var $dropdownWrapper = $('.t4s-dropdown__wrapper.is--opened');
        if ($dropdownWrapper.length === 0) return;

        // Check if the focused element is within the dropdown
        var $focusedElement = $(document.activeElement);
      
        if (!$focusedElement.closest($dropdownWrapper).length) return;
    
        // Handle up/down arrow keys
        if (event.key === 'ArrowDown'){
            event.preventDefault();
             var $items = $dropdownWrapper.find('[data-dropdown-item]');
               $next = $focusedElement.nextAll('[data-dropdown-item]:not(:disabled)').first();
                if ($next.length === 0) {
                    $next = $items.not(':disabled').first();
                }
            $next.focus();
           $('#sticky-dropdown').attr('aria-activedescendant',$next.attr('id'));
        }else if (event.key === 'ArrowUp'){
            event.preventDefault();
             var $items = $dropdownWrapper.find('[data-dropdown-item]');
               $next = $focusedElement.prevAll('[data-dropdown-item]:not(:disabled)').first();
                if ($next.length === 0) {
                    $next = $items.not(':disabled').first();
                }
            $next.focus();
            $('#sticky-dropdown').attr('aria-activedescendant',$next.attr('id'));
        }else if (event.key === 'Escape'){
setTimeout(function(){
$('#sticky-dropdown').removeAttr('aria-activedescendant');
          $('#sticky-dropdown').focus();
},100);
        }else if (event.key === 'Tab'){
setTimeout(function(){
 var $next = $(document.activeElement);
          $('#sticky-dropdown').attr('aria-activedescendant',$next.attr('id'));
},100);
        }
    });
function checkCurrent(){  const slideNav=document.querySelectorAll('.t4s-col-thumb .t4s-carousel__nav-item');slideNav.forEach(function(e){e.classList.contains('is-nav-selected')?(e.setAttribute('aria-current','true')):(e.removeAttribute('aria-current'))})}
function addWrapperDiv(){
  var $div1 = $('#pwsp__div1');
    var $div2 = $('#pswp__div2');
    
    // Create the wrapper div with the specified attributes
    var $wrapperDiv = $('<div>', {
        role: 'region',
        'aria-label': 'Zoomed Product Image Carousel'
    });
    
    // Insert the wrapper div before the first div
    $div1.before($wrapperDiv);
    
    // Move the two divs inside the wrapper div
    $wrapperDiv.append($div1).append($div2);
}
jQuery_T4NT(document).on('keydown', '.t4s-modal--is-active div[data-testid="ShopifyPay-button"]', function(event) {
	// Add an event listener to the checkout button to trap focus
 if (!$('.t4s-modal--is-active').find('.shopify-payment-button__more-options').length) {
if (event.shiftKey && event.key === 'Tab') {
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			$('.t4s-product-form__submit').focus();
	}else if (event.key === 'Tab') {	
			event.preventDefault(); // Prevent default tab behavior
			//  console.log('Working');
			$('.t4s-modal-close').focus();
	}
 }
});
jQuery_T4NT(document).on('keydown', '.t4s-product-quick-shop .t4s-swatch__item', function(event) {
var $this=$(this);
        if (event.key === 'Enter') {
         setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
		// console.log('Working');
if($this.hasClass('is--soldout')){
			localStorage.setItem('tabShiftElement','.t4s-pr__notify-stock');
}else{
  localStorage.setItem('tabShiftElement', '.shopify-payment-button__more-options');
}
		}, 50);
        }
    });
jQuery_T4NT(document).on('keydown', '.t4s-modal--is-active', function(event) {
        if (event.key === 'Escape') {
         setTimeout(function() {
			event.preventDefault(); // Prevent default tab behavior
		// console.log('Working');
			var lastModalElement = localStorage.getItem('escElement');
			$(lastModalElement).focus();
		}, 250);
        }
    });
jQuery_T4NT(document).on('keydown', 'ul[role="tablist"]', function(event) {
var $ul = $(this);
    var $tabs = $ul.find('li a');    
    var currentIndex = $tabs.index($('.t4s-active'));
    var lit = $tabs.length - 1;

    if (event.key === 'ArrowLeft') {
      if (currentIndex > 0) {
        currentIndex--;
      } else {
        currentIndex = lit;
      }
      $tabs.eq(currentIndex).click().focus();
    } else if (event.key === 'ArrowRight') {
      if (currentIndex < lit) {
        currentIndex++;
      } else {
        currentIndex = 0;
      }
      $tabs.eq(currentIndex).click().focus();
    }
  });